import React from "react";
import PropTypes from "prop-types";
import styles from "./ApplicationStepper.module.scss";

/**
 * ApplicationStepper component
 * Displays the application progress steps in the thank you page
 */
const ApplicationStepper = ({ currentStep = 1 }) => {
  const steps = [
    { id: 1, label: "Application sent" },
    { id: 2, label: "Verification" },
    { id: 3, label: "Approved" },
    { id: 4, label: "Deployment" },
    { id: 5, label: "Done" },
  ];

  return (
    <div className={styles.stepperContainer}>
      {steps.map((step, index) => (
        <div key={step.id} className={styles.stepItem}>
          <div className={styles.stepVisual}>
            <div 
              className={`${styles.stepCircle} ${step.id <= currentStep ? styles.active : ''}`}
            />
            {index < steps.length - 1 && (
              <div 
                className={`${styles.stepLine} ${step.id <= currentStep ? styles.active : ''}`}
              />
            )}
          </div>
          <span 
            className={`${styles.stepLabel} ${step.id <= currentStep ? styles.activeLabel : ''}`}
          >
            {step.label}
          </span>
        </div>
      ))}
    </div>
  );
};

ApplicationStepper.propTypes = {
  currentStep: PropTypes.number
};

export default ApplicationStepper; 